import React from 'react';
import { compose } from 'recompose';
import { getAuth } from '../store/actions/auth';
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

const mapStateToProps = (state) => {
    return {
        authorized: state.auth.authorized
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAuth: () => dispatch(getAuth())
    }
}

const UnAuthorizedPage = ({children, authorized}) => {
    if (authorized) {
        return (<Redirect to="/start" />);
    }

    return (
        <div className="UnAuthorizedPage">
            {children}
        </div>
    );
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps))(UnAuthorizedPage);


// WEBPACK FOOTER //
// ./src/pages/UnAuthorizedPage.js